import { render, staticRenderFns } from "./processing-legal-recommendation.vue?vue&type=template&id=55da31d4"
import script from "./processing-legal-recommendation.vue?vue&type=script&lang=js"
export * from "./processing-legal-recommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports